<template>
  <div>
    <b-modal
      id="contract-template-form-modal"
      ref="modal"
      :ok-title="$t('general.save')"
      :ok-disabled="isProcessing"
      size="sm"
      centered
      no-close-on-backdrop
      @shown="onShow"
      @ok="onOk"
    >
      <form ref="form" @submit="save">
        <fields :model="model" :errors="errors" ungrouped layout="vertical" />
      </form>
    </b-modal>
  </div>
</template>

<script>
import Api from './Api'
import { ResourceFormMixin } from 'stylemix-vue-admin'

export default {
  name: 'ContractTemplateFormModal',

  mixins: [ResourceFormMixin],

  data() {
    return {
      isProcessing: false,
    }
  },

  methods: {
    api() {
      return new Api()
    },
    onOk(event) {
      this.isProcessing = true
      event.preventDefault()
      this.save()
        .then(result => {
          this.$bvModal.hide('contract-template-form-modal')
          this.$toast.success(result.message)
          this.$emit('saved')
        })
        .finally(() => {
          this.isProcessing = false
        })
    },
    onShow() {
      this.isProcessing = true
      this.loadForm().finally(() => {
        this.isProcessing = false
      })
    },
  },
}
</script>
